<template>
  <div id="app" class="container">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   document.getElementById("preload").remove();
    //   document.getElementsByTagName("BODY")[0].removeAttribute("style");
    // }, 1500);
  },
  async created() {
    // statik veriler
    this.$store.dispatch("language", this.$route.params.lang);
    await this.$store.dispatch("INIT_TOKEN");
    this.$store.dispatch("homepage_list");

    this.$store.dispatch("slider_list");
    this.$store.dispatch("static_content");
    this.$store.dispatch("select_options", [
      "work",
      "performer",
      "lyricist",
      "editor",
      "composer",
      "album",
    ]);
    this.$store.dispatch("products_list");
    this.$store.dispatch("videopage_menu");
    this.$store.dispatch("photos_menu");

    this.$nextTick(() => {
      document.getElementById("preload").remove();
      document.getElementsByTagName("BODY")[0].removeAttribute("style");
    });
    return;
  },
};
</script>

<style lang="scss">
@import "styles/colors"; // color mixins
@import "styles/styles"; // global styles
.extra-image {
  span {
    display: block;
    height: 100%;
    .progressive-image-wrapper {
      height: 100%;
      padding: 0 !important;
      margin: 0;
      img {
        height: 100%;
      }
    }
  }
}
</style>
